import { render } from "./DialogExpiredCouponCode.vue?vue&type=template&id=713a9f28"
import script from "./DialogExpiredCouponCode.vue?vue&type=script&lang=js"
export * from "./DialogExpiredCouponCode.vue?vue&type=script&lang=js"
script.render = render

export default script